import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-ic_gantan",
  "use": "icon-ic_gantan-usage",
  "viewBox": "0 0 7 10",
  "content": "<symbol viewBox=\"0 0 7 10\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-ic_gantan\">\r\n<path d=\"M6.52154 1.61918L4.8384 0.670661L2.29204 5.97131L3.29564 6.53689L6.52154 1.61918ZM2.26412 9.02725L3.13605 7.48002L1.57837 6.6022L0.706438 8.14943L2.26412 9.02725Z\" fill=\"#F2C655\" />\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol